import type { CatalogRatioDataFilterInput } from '@gql/graphql';
import type { SelectedFilters } from '@uikit';
import type { AnyObject } from 'types/AnyObject';

import * as R from 'ramda';
import type { Dispatch, SetStateAction } from 'react';

export const ColumnPairs = {
    updatedAt: 'Дата обновления',
    groupName: 'Раздел',
    code: 'Шифр',
    name: 'Наименование',
    ratioType: 'Тип коэффициента',
    ratios: 'Коэффициенты',
    kozp: 'К озп',
    kem: 'К эмм',
    knr: 'К нр',
    ksp: 'К сп',
    kmat: 'К мат',
    ktz: 'К тз озп',
    ktzzpm: 'К тз змп',
    justification: 'Обоснование',
};

export const defaultSet = {
    sortable: true,
    comparator: () => 0,
};

type TSavedFilterValues = string | Record<string, ({ value: any; data: any } | string)[]>;

export const getValuesFromSaved =
    ({ setQueryWhere }: { setQueryWhere: Dispatch<SetStateAction<AnyObject>> }) =>
    ({ savedValuesArray }: { savedValuesArray: [string, TSavedFilterValues][] | null }) => {
        const valuesFromSaved = savedValuesArray?.reduce((acc: Record<string, any>, [name, value]) => {
            if (name && value) {
                Object.entries(value ?? {}).forEach(([key, val]) => {
                    if (key === 'updatedAt' && Array.isArray(val)) {
                        acc[key] = {
                            selected: [key],
                            value: val.map((v: string) => (v ? new Date(v) : undefined)),
                        };
                    } else {
                        acc[key] = {
                            selected: [key],
                            value: val?.map((v: { data: any }) => ({ data: v.data })),
                        };
                    }
                });

                return acc;
            }

            return acc;
        }, {});

        if (valuesFromSaved) {
            setQueryWhere(valuesFromSaved);
        }
    };

export enum RatiosTypeEnum {
    CONSTRAINT_COEF = 'Особых условий',
    TECH_PART_COEF = 'Технической части',
    DISMANTLING_COEF = 'Демонтаж',
}

export const getWhereVariables = (filters: SelectedFilters): CatalogRatioDataFilterInput | undefined => {
    const predicates = Object.entries(filters)
        .filter(([, { selected, value }]) => selected.length && !R.isNil(value) && value.length)
        .map(([fieldName, { value }]) => {
            if (fieldName === 'updatedAt' && Array.isArray(value)) {
                const dateFrom = value[0] ? new Date(value[0]).toISOString() : undefined;
                const dateTo = value[1] ? new Date(value[1]) : undefined;

                if (dateTo) {
                    dateTo.setDate(dateTo.getDate() + 1);
                }

                return {
                    [fieldName]: {
                        gte: dateFrom,
                        lt: dateTo?.toISOString(),
                    },
                };
            }

            return {
                [fieldName]: { in: value.map(({ data }: { data: { value: string } }) => data.value) },
            };
        });

    return predicates.length
        ? {
              and: predicates,
          }
        : undefined;
};
